<template>
	<div class="clock-container">
		<img src="/static/img/clock.png" alt="clock" width="47" height="47" />
		<div class="time-container">
			<p class="label">Tiempo:</p>
			<p class="time">
				{{minute | formatTime}}:{{second | formatTime}}
			</p>
		</div>
	</div>
</template>

<script>

function created() {
	if (this.realTime) {
		this.intervalId = setInterval(() => {
			this.$emit('increase-time');
		}, 1000);
	}
}

function data() {
	return {
		intervalId: null,
	};
}

function formatTime(value) {
	return value < 10 ? `0${value}` : value;
}

function destroyed() {
	clearInterval(this.intervalId);
}

export default {
	created,
	data,
	destroyed,
	filters: {
		formatTime,
	},
	name: 'clock',
	props: {
		minute: {
			type: Number,
			default: 0,
		},
		second: {
			type: Number,
			default: 0,
		},
		realTime: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.clock-container {
	display: flex;

	p {
		margin: 0;
	}

	.time-container {
		align-items: flex-start;
		display: flex;
		flex-direction: column;
		margin-left: 11px;

		.label {
			color: map-get($colors, default-dark);
			font-family: map-get($fonts, medium);
			font-size: 14px;
			font-weight: 500;
			line-height: 1;
		}

		.time {
			color: map-get($colors, clock-grey);
			font-family: map-get($fonts, compactUltraLight);
			font-size: 40px;
			font-weight: 200;
			line-height: 0.8;
		}
	}
}
</style>





// WEBPACK FOOTER //
// Clock.vue?74b81e8a